import { Component, Input } from '@angular/core';
import { LowerCasePipe } from '@angular/common';

@Component({
  selector: 'mwe-product-card-tariff-list-fernwaerme',
  templateUrl: './product-card-tariff-list-fernwaerme.component.html',
  imports: [LowerCasePipe],
})
export class ProductCardTariffListFernwaermeComponent {
  @Input() tariffClasses: string[];
}
